import { LayoutModule } from '@angular/cdk/layout';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { EnvironmentProviders, importProvidersFrom, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS } from '@angular/material/button-toggle';
import { MAT_CHECKBOX_DEFAULT_OPTIONS, MatCheckboxDefaultOptions } from '@angular/material/checkbox';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE, MAT_NATIVE_DATE_FORMATS, MatDateFormats } from '@angular/material/core';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogConfig } from '@angular/material/dialog';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldDefaultOptions } from '@angular/material/form-field';
import { MAT_ICON_DEFAULT_OPTIONS, MatIconDefaultOptions } from '@angular/material/icon';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS, MatSnackBarConfig, MatSnackBarModule } from '@angular/material/snack-bar';
import { provideDateFnsAdapter } from '@angular/material-date-fns-adapter';
import { enGB } from 'date-fns/locale';
import { NGX_CURRENCY_CONFIG, NgxCurrencyConfig } from 'ngx-currency';

import { IconService } from '../shared/services/icon.service';
import { PopoverService } from '../shared/services/popover.service';
import { ToastService } from '../shared/services/toast.service';
import { RightSidenavStore } from '../shared/store/right-sidenav.store';

export const DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'dd MMM yyyy',
  },
  display: {
    dateInput: 'dd MMM yyyy',
    monthYearLabel: 'MMM yyyy',
    dateA11yLabel: 'dd MMM yyyy',
    monthYearA11yLabel: 'MMM yyyy',
  },
};

export function provideCore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    importProvidersFrom(LayoutModule, MatSnackBarModule),
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        appearance: 'fill',
        floatLabel: 'always',
      } as MatFormFieldDefaultOptions,
    },
    {
      provide: MAT_CHECKBOX_DEFAULT_OPTIONS,
      useValue: {
        color: 'primary',
      } as MatCheckboxDefaultOptions,
    },
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: {
        duration: 5000,
      } as MatSnackBarConfig,
    },
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { showError: true },
    },
    {
      provide: MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS,
      useValue: {
        hideSingleSelectionIndicator: true,
      },
    },
    {
      provide: MAT_ICON_DEFAULT_OPTIONS,
      useValue: {
        fontSet: 'material-symbols-outlined',
      } as MatIconDefaultOptions,
    },
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: {
        minWidth: '50vw',
      } as MatDialogConfig,
    },
    {
      provide: NGX_CURRENCY_CONFIG,
      useValue: {
        align: 'left',
        allowNegative: false,
        prefix: '',
        suffix: '',
        precision: 0,
      } as NgxCurrencyConfig,
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: DATE_FORMATS,
    },
    {
      provide: MAT_NATIVE_DATE_FORMATS,
      useValue: DATE_FORMATS,
    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: enGB,
    },
    IconService,
    PopoverService,
    ToastService,
    RightSidenavStore,
    provideDateFnsAdapter(DATE_FORMATS),
    provideAppInitializer(() => {
      inject(IconService).registerCustomIcons();
    }),
  ]);
}
